<template>
  <div id="page-top">
    <div id="wrapper">
      <Navbar></Navbar>
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          <Topbar></Topbar>
          <div class="container-fluid">
            <transition name="fade">
              <div id="preloader">
                <div data-loader="circle-side"></div>
              </div>
            </transition>
            <transition name="fade">
              <div id="loader_form">
                <div data-loader="circle-side-2"></div>
              </div>
            </transition>
            <div class="card shadow mb-4">
              <div class="card-header py-3 d-flex align-items-center justify-content-between">
                <h6 class="m-0 font-weight-bold text-dark">Rôles</h6>
                <button class="btn btn-sm btn-success shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#addModalRole" v-bind:disabled="addRoleProcess || editRoleProcess || deleteRoleProcess"><i class="fas fa-plus fa-md"></i></button>
              </div>
              <div class="card-body">
                <transition name="fade">
                  <div v-if="messageAlert" class="alert p-3" v-bind:class="{ 'alert-success': isSuccess, 'alert-danger': isError }" role="alert">
                    {{messageAlert}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </transition>
                <!-- Table Rôle -->
                <div class="table-responsive">
                  <table class="table table-hover table-bordered" id="dataTableRole" width="100%" cellspacing="0">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th class="d-none">Id</th>
                        <th>Code</th>
                        <th>Nom</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tfoot>
                      <tr>
                        <th>#</th>
                        <th class="d-none">Id</th>
                        <th>Code</th>
                        <th>Nom</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </tfoot>
                    <tbody>
                      <tr v-for="(item, index) in roles" v-bind:key="item.id">
                        <td>{{index+1}}</td>
                        <td class="d-none">{{item.id}}</td>
                        <td>{{item.code}}</td>
                        <td>{{item.name}}</td>
                        <td class="text-center">
                          <button class="btn btn-sm btn-primary shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#viewModalRole" v-on:click="viewRole(item.id)" v-bind:disabled="addRoleProcess || editRoleProcess || deleteRoleProcess">
                          <i class="fas fa-eye fa-md"></i>
                          </button>
                          <button class="btn btn-sm btn-warning shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#editModalRole" v-on:click="viewRole(item.id)" v-bind:disabled="addRoleProcess || editRoleProcess || deleteRoleProcess">
                          <i class="fas fa-pencil-alt fa-md"></i>
                          </button>
                          <button class="btn btn-sm btn-danger shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#deleteModalRole" v-on:click="viewRole(item.id)" v-bind:disabled="addRoleProcess || editRoleProcess || deleteRoleProcess">
                          <i class="fas fa-trash fa-md"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
    <a class="scroll-to-top rounded" href="#page-top">
    <i class="fas fa-angle-up"></i>
    </a>
    <!-- Add Modal Rôle -->
    <div class="modal fade" id="addModalRole" tabindex="-1" role="dialog" aria-labelledby="ModalRoleLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="addRoleForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalRoleLabel">Ajouter Rôle</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-6">
                  <label>Code</label>
                  <input type="codeber" class="form-control mb-2" v-model="code1" name="code1" required>
                </div>
                <div class="col-sm-6">
                  <label>Nom</label>
                  <input type="text" class="form-control mb-2" v-model="name1" name="name1" required>
                </div>
                <div class="col-sm-12">
                  <label>Description</label>
                  <textarea class="form-control mb-2" v-model="description1" name="description1" required></textarea>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-success text-uppercase w-50" href="javascript:(0)" v-on:click="addRole" v-bind:disabled="addRoleProcess || editRoleProcess || deleteRoleProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="addRoleProcess">
              Ajouter
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- View Modal Rôle -->
    <div class="modal fade" id="viewModalRole" tabindex="-1" role="dialog" aria-labelledby="ModalRoleLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalRoleLabel">Rôle [#<span>{{indexRole+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th scope="row">Id</th>
                  <td>{{id2}}</td>
                </tr>
                <tr>
                  <th scope="row">Code</th>
                  <td>{{code2}}</td>
                </tr>
                <tr>
                  <th scope="row">Nom</th>
                  <td>{{name2}}</td>
                </tr>
                <tr>
                  <th scope="row">Description</th>
                  <td>{{description2}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary text-uppercase w-50" href="javascript:(0)" data-dismiss="modal">
            Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit Modal Rôle -->
    <div class="modal fade" id="editModalRole" tabindex="-1" role="dialog" aria-labelledby="ModalRoleLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="editRoleForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalRoleLabel">Modifier Rôle [#<span>{{indexRole+1}}</span>]</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-6">
                  <label>Code</label>
                  <input type="codeber" class="form-control mb-2" v-model="code3" name="code3" required>
                </div>
                <div class="col-sm-6">
                  <label>Nom</label>
                  <input type="text" class="form-control mb-2" v-model="name3" name="name3" required>
                </div>
                <div class="col-sm-12">
                  <label>Description</label>
                  <textarea class="form-control mb-2" v-model="description3" name="description3" required></textarea>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-warning text-uppercase w-50" href="javascript:(0)" v-on:click="editRole" v-bind:disabled="addRoleProcess || editRoleProcess || deleteRoleProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="editRoleProcess">
              Modifier
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Delete Modal Rôle -->
    <div class="modal fade" id="deleteModalRole" tabindex="-1" role="dialog" aria-labelledby="ModalRoleLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalRoleLabel">Supprimer Rôle [#<span>{{indexRole+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-center text-uppercase mt-3">êtes-vous sûr de vouloir supprimer ce rôle ?</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-danger text-uppercase w-50" href="javascript:(0)" v-on:click="deleteRole" v-bind:disabled="addRoleProcess || editRoleProcess || deleteRoleProcess">
            <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="deleteRoleProcess">
            Supprimer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s
}
.fade-enter,
.fade-leave-to {
  opacity: 0
}
#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  z-index: 999999;
}
[data-loader="circle-side"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
#loader_form {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 999999;
  display: none;
}
[data-loader="circle-side-2"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
@-webkit-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>

<script>
import Navbar from './Navbar'
import Topbar from './Topbar'
import Footer from './Footer'
import axios from 'axios'
$.fn.isValid = function () {
  return this[0].checkValidity()
}
export default {
  name: 'App',
  components: {
    'Topbar': Topbar,
    'Navbar': Navbar,
    'Footer': Footer
  },
  data () {
    return {
      loading: true,
      progress: 0,
      role: {},
      indexRole: '',
      roles: [],
      isSuccess: true,
      isError: false,
      messageAlert: '',
      addRoleProcess: false,
      viewRoleProcess: false,
      editRoleProcess: false,
      deleteRoleProcess: false,
      code1: '',
      name1: '',
      description1: '',
      id2: '',
      code2: '',
      description2: '',
      name2: '',
      code3: '',
      name3: '',
      description3: '',
      dTableRole: ''
    }
  },
  methods: {
    //Initialiser variables et tables
    init () {
      setTimeout(() => {
        this.dTableRole = $('#dataTableRole').DataTable({
          'columns': [
            { 'width': '15' },
            null,
            null,
            null,
            { 'width': '100' }
          ],
          'lengthMenu': [
            [10],
            [10]
          ],
          order: [
            [0, 'desc']
          ],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true
        })
        this.role = {
          'id': '',
          'code': '',
          'name': ''
        }
        this.code1 = ''
        this.name1 = ''
        this.description1 = ''
        this.id2 = ''
        this.code2 = ''
        this.name2 = ''
        this.description2 = ''
        this.code3 = ''
        this.name3 = ''
        this.description3 = ''
      }, 50)
    },
    //Sélectionner tous les rôles (Base de données)
    getRoles () {
      axios.get(this.apiUrl+'/roles', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.roles = res.data
          this.progress += 1
          if (this.progress === 1) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    //Ajouter un rôle
    addRole () {
      if ($('#addRoleForm').isValid()) {
        this.addRoleProcess = true
        let role = {
          'id': this.roles.length + 1,
          'code': this.code1,
          'name': this.name1,
          'description': this.description1
        }
        axios.post(this.apiUrl+'/roles', role, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status == 201) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement ajouté avec succès'
            this.roles.push(role)
            this.dTableRole.destroy()
            this.init()
          }
          $('#addModalRole').modal('hide')
          this.addRoleProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#addModalRole').modal('hide')
          this.addRoleProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }
    },
    //Sélectionner un rôle (Local)
    viewRole (id) {
      this.role = this.roles.filter(function (item) {
        return item.id === id
      })[0]
      this.indexRole = this.roles.indexOf(this.role)
      this.id2 = this.role.id
      this.code2 = this.role.code
      this.name2 = this.role.name
      this.description2 = this.role.description
      this.code3 = this.role.code
      this.name3 = this.role.name
      this.description3 = this.role.description
    },
    //Modifier un rôle
    editRole () {
      if ($('#editRoleForm').isValid()) {
        var id = this.role.id
        this.editRoleProcess = true
        axios.put(this.apiUrl+'/roles/' + id, {
          code: this.code3,
          name: this.name3,
          description: this.description3
        }, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status == 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement modifié avec succès'
            this.role.code = this.code3
            this.role.name = this.name3
            this.role.description = this.description3
            this.roles[this.indexRole] = this.role
            this.dTableRole.destroy()
            this.init()
          }
          $('#editModalRole').modal('hide')
          this.editRoleProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#editModalRole').modal('hide')
          this.editRoleProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }
    },
    //Supprimer un rôle
    deleteRole () {
      var id = this.role.id
      this.deleteRoleProcess = true
      axios.delete(this.apiUrl+'/roles/' + id, {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          if (res.status == 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement supprimé avec succès'
            this.roles.splice(this.indexRole, 1)
            this.dTableRole.destroy()
            this.init()
          }
          $('#deleteModalRole').modal('hide')
          this.deleteRoleProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#deleteModalRole').modal('hide')
          this.deleteRoleProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
    }
  },
  created () {
    $('body').css({'overflow': 'hidden'})
    this.getRoles()
  },
  watch: {
    loading: function () {
      this.init()
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      $('[data-loader="circle-side"]').fadeOut()
      $('#preloader').delay(350).fadeOut('slow')
      $('body').delay(350).css({
        'overflow': 'auto'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Role.vue